/**
 * Предложение бота «по вызову» в переписке: заметка бота с content_attributes.unia_bot_proposal
 * (Unia::BotInvocations.note!): { title, confirm_label, details, invocation_id, state, decided_by }.
 * state: pending → confirmed | cancelled.
 */
import type { CwMessage } from '@/api/inboxTypes';

export interface BotProposal {
  invocationId: number;
  title: string;
  confirmLabel: string | null;
  state: 'pending' | 'confirmed' | 'cancelled';
  decidedBy: string | null;
  details: Array<[string, string]>;
}

const STATES = new Set(['pending', 'confirmed', 'cancelled']);

/** Достаём предложение из сообщения; null — это не предложение. */
export function proposalOf(m: Pick<CwMessage, 'content_attributes'>): BotProposal | null {
  const raw = m.content_attributes?.unia_bot_proposal;
  if (!raw || typeof raw !== 'object') return null;
  const p = raw as Record<string, unknown>;
  const id = Number(p.invocation_id);
  if (!Number.isInteger(id) || id <= 0) return null;
  const state = typeof p.state === 'string' && STATES.has(p.state) ? (p.state as BotProposal['state']) : 'pending';
  const details = p.details && typeof p.details === 'object' && !Array.isArray(p.details)
    ? Object.entries(p.details as Record<string, unknown>)
        .filter(([, v]) => v !== null && v !== undefined && typeof v !== 'object')
        .map(([k, v]) => [k, String(v)] as [string, string])
    : [];
  return {
    invocationId: id,
    title: typeof p.title === 'string' && p.title ? p.title : 'Предложение бота',
    confirmLabel: typeof p.confirm_label === 'string' && p.confirm_label ? p.confirm_label : null,
    state,
    decidedBy: typeof p.decided_by === 'string' && p.decided_by ? p.decided_by : null,
    details,
  };
}

/** Какие сообщения предложить боту по умолчанию: последние живые реплики переписки (не служебные, не заметки). */
export function defaultBotMessages(messages: Array<Pick<CwMessage, 'id' | 'message_type' | 'private'>>, take = 5): number[] {
  return messages
    .filter((m) => m.id > 0 && !m.private && (m.message_type === 0 || m.message_type === 1))
    .slice(-take)
    .map((m) => m.id);
}
